// AUTO-GENERATED by scripts/build-product-photos.js
// Product catalog — the single source of truth (Firebase was removed).
// To edit a product: change the fields here. To change a photo: replace
// the file in src/assets/bbs/products/ (keep the same name), or re-run
// the build script with an updated mapping.

const products = [
  {
    id: "bezdratovy-reproduktor",
    name: "Bezdrátový reproduktor",
    price: "600",
    weekendPrice: "800",
    bail: "2000",
    context: "Bezdrátový párty reproduktor s výkonem až 500 W, světelnými efekty a vstupem na mikrofon. Snadno jej přepravíte pomocí koleček a rukojeti.",
    category: "party vybavení",
    featured: false,
    img: require("../assets/bbs/products/bezdratovy-reproduktor.jpg"),
  },
  {
    id: "bistro-stolek",
    name: "Bistro stolek",
    price: "150",
    weekendPrice: "200",
    bail: "1000",
    context: "Barový stolek, výška 150 cm, průměr 60 cm",
    category: "party nábytek",
    featured: false,
    img: require("../assets/bbs/products/bistro-stolek.jpg"),
  },
  {
    id: "drevene-skladaci-lehatko",
    name: "Dřevěné skládací lehátko",
    price: "120",
    weekendPrice: "150",
    bail: "300",
    context: "Lehátko je možno polohovat ve třech stupních. Známé též jako plážové lehátko.",
    category: "party nábytek",
    featured: false,
    img: require("../assets/bbs/products/drevene-skladaci-lehatko.jpg"),
  },
  {
    id: "halogen-prenosny",
    name: "halogen přenosný",
    price: "100",
    weekendPrice: "150",
    bail: "500",
    context: "Ledkový halogen 20 W, vhodný zejména k osvětlení party stanů, praktický skřipec na uchycení.",
    category: "ostatní",
    featured: false,
    img: require("../assets/bbs/products/halogen-prenosny.jpg"),
  },
  {
    id: "chafing",
    name: "chafing",
    price: "250",
    weekendPrice: "350",
    bail: "2000",
    context: "Profi zařízení pro ohřívání jídla a udržování potravin v teple.",
    category: "cateringové vybavení",
    featured: false,
    img: require("../assets/bbs/products/chafing.jpg"),
  },
  {
    id: "kavovy-salek",
    name: "Kávový šálek",
    price: "9",
    weekendPrice: "10",
    bail: "50",
    context: "Kávový šálek Praha",
    category: "cateringové vybavení",
    featured: false,
    img: require("../assets/bbs/products/kavovy-salek.jpg"),
  },
  {
    id: "nerezovy-tac-na-misy",
    name: "Nerezový tác na mísy",
    price: "25",
    weekendPrice: "40",
    bail: "200",
    context: "Nerezový tác o rozměru 30 x 40 cm, vhodný na obložené mísy, chlebíčky apod.",
    category: "cateringové vybavení",
    featured: false,
    img: require("../assets/bbs/products/nerezovy-tac-na-misy.jpg"),
  },
  {
    id: "nuzkovy-stan-3x3",
    name: "nůžkový stan 3 x 3 m",
    price: "1100",
    weekendPrice: "1500",
    bail: "2000",
    context: "Nůžkový stan 3 x 3 m, vhodný na Vaši oslavu či party, možný jako prodejní stánek, jednoduchá montáž, součástí je kotvicí sada a 4 bočnice.",
    category: "party stany",
    featured: false,
    img: require("../assets/bbs/products/nuzkovy-stan-3x3.jpg"),
  },
  {
    id: "nuzkovy-stan-3x45",
    name: "Nůžkový stan 3 x 4,5 m",
    price: "1500",
    weekendPrice: "1800",
    bail: "2000",
    context: "Nůžkový stan 3 x 4,5 m, vhodný na Vaši oslavu či party, možný jako prodejní stánek, jednoduchá montáž, součástí je kotvicí sada a 4 bočnice.",
    category: "party stany",
    featured: false,
    img: require("../assets/bbs/products/nuzkovy-stan-3x45.jpg"),
  },
  {
    id: "nuzkovy-stan-3x6",
    name: "nůžkový stan 3 x 6 m",
    price: "1800",
    weekendPrice: "2000",
    bail: "2000",
    context: "Nůžkový stan 3 x 6 m, vhodný na Vaši oslavu či party, možný jako prodejní stánek, jednoduchá montáž, součástí je kotvicí sada a 4 bočnice.",
    category: "party stany",
    featured: false,
    img: require("../assets/bbs/products/nuzkovy-stan-3x6.jpg"),
  },
  {
    id: "nuzkovy-stan-3x6-premium",
    name: "nůžkový stan 3 x 6 m Premium",
    price: "2800",
    weekendPrice: "3000",
    bail: "3000",
    context: "Nůžkový stan 3 x 6 m, vhodný na Vaši oslavu či party, možný jako prodejní stánek, jednoduchá montáž, součástí je kotvicí sada a 4 bočnice.",
    category: "party stany",
    featured: false,
    img: require("../assets/bbs/products/nuzkovy-stan-3x6-premium.jpg"),
  },
  {
    id: "ohrivaci-soudek",
    name: "Ohřívací soudek",
    price: "200",
    weekendPrice: "250",
    bail: "1000",
    context: "Ohřívací soudek na polévky, guláše aj., ocení především ti, kteří polévku připravují nebo pouze servírují ve venkovních prostorech. Objem 10 l.",
    category: "cateringové vybavení",
    featured: false,
    img: require("../assets/bbs/products/ohrivaci-soudek.jpg"),
  },
  {
    id: "ohrivac-napoju-10l",
    name: "Ohřívač nápojů 10l",
    price: "200",
    weekendPrice: "250",
    bail: "1000",
    context: "Nerezový ohřívač nápojů s termostatem a kohoutkem, vhodný zejména na ohřev vody, svařeného vína apod.",
    category: "cateringové vybavení",
    featured: false,
    img: require("../assets/bbs/products/ohrivac-napoju-10l.jpg"),
  },
  {
    id: "ohrivac-napoju-25l",
    name: "Ohřívač nápojů 25l",
    price: "250",
    weekendPrice: "300",
    bail: "1000",
    context: "Praktický ohřívač nápojů s termostatem, časovačem a kohoutkem. Vhodný zejména na ohřev vody, svařeného vína apod.",
    category: "cateringové vybavení",
    featured: false,
    img: require("../assets/bbs/products/ohrivac-napoju-25l.jpg"),
  },
  {
    id: "party-balicek",
    name: "party balíček",
    price: "9900",
    weekendPrice: "9900",
    bail: "10000",
    context: "Party balíček obsahuje: party stan 6 x 12 m, 8 pivních setů, 4 bistro stolky, 1 skládací bar, 2 stojany na odpadky, 2 halogeny na osvětlení stanu, montáž a demontáž zdarma.",
    category: "party stany",
    featured: true,
    img: require("../assets/bbs/products/party-balicek.jpg"),
  },
  {
    id: "pivni-set",
    name: "Pivní set",
    price: "200",
    weekendPrice: "210",
    bail: "1000",
    context: "Skládací pivní set: stůl 220 x 50 cm, 2 lavice 220 x 25 cm.",
    category: "party nábytek",
    featured: true,
    img: require("../assets/bbs/products/pivni-set.jpg"),
  },
  {
    id: "plynove-topidlo",
    name: "plynové topidlo",
    price: "350",
    weekendPrice: "400",
    bail: "2000",
    context: "Plynový zářič o výkonu 13 kWh, rozměr 220 x 85 cm, termostat, zapalovač, snadná obsluha. Propanbutanová lahev není součástí.",
    category: "party vybavení",
    featured: false,
    img: require("../assets/bbs/products/plynove-topidlo.jpg"),
  },
  {
    id: "polevkova-miska-praha",
    name: "Polévková miska Praha",
    price: "9",
    weekendPrice: "10",
    bail: "50",
    context: "Polévková miska objem 450ml",
    category: "cateringové vybavení",
    featured: false,
    img: require("../assets/bbs/products/polevkova-miska-praha.jpg"),
  },
  {
    id: "potah-na-bistro-stolek",
    name: "Potah na bistro stolek",
    price: "150",
    weekendPrice: "200",
    bail: "400",
    context: "Bílý povlak na bistro stolek ze strečového materiálu, vhodný zejména na svatby.",
    category: "party vybavení",
    featured: false,
    img: require("../assets/bbs/products/potah-na-bistro-stolek.jpg"),
  },
  {
    id: "potah-na-pivni-set",
    name: "potah na pivní set",
    price: "250",
    weekendPrice: "300",
    bail: "1000",
    context: "Sada obsahuje: ubrus na stůl a 2 povlaky na pivní lavice, z pevné silné polyesterové látky. Působí luxusním dojmem.",
    category: "party vybavení",
    featured: false,
    img: require("../assets/bbs/products/potah-na-pivni-set.jpg"),
  },
  {
    id: "prodluzovaci-kabel-25m",
    name: "Prodlužovací kabel 25 m",
    price: "200",
    weekendPrice: "250",
    bail: "1000",
    context: "Profesionální prodlužovací kabel na bubnu, délka 25 m, 4 zásuvky, max. 13 A / 3000 W; 4,35 A / 1000 W při navinutém kabelu.",
    category: "ostatní",
    featured: false,
    img: require("../assets/bbs/products/prodluzovaci-kabel-25m.jpg"),
  },
  {
    id: "profi-party-stan-6x12",
    name: "Profi party stan 6 x 12 m",
    price: "8000",
    weekendPrice: "8000",
    bail: "5000",
    context: "Profi party stan určený na velké oslavy, svatby či firemní party. Plachta PVC, výška bočnice 2 m, cena zahrnuje montáž a demontáž.",
    category: "party stany",
    featured: true,
    img: require("../assets/bbs/products/profi-party-stan-6x12.jpg"),
  },
  {
    id: "rautovy-stul-skladaci",
    name: "Rautový stůl skládací",
    price: "300",
    weekendPrice: "350",
    bail: "1000",
    context: "Skladací rautový stůl 180x76 cm",
    category: "party nábytek",
    featured: false,
    img: require("../assets/bbs/products/rautovy-stul-skladaci.jpg"),
  },
  {
    id: "skladaci-bar",
    name: "Skládací bar",
    price: "300",
    weekendPrice: "500",
    bail: "2000",
    context: "Skládací bar 120 (V) x 60 (H) x 120 (Š) cm, vhodný na výdej nápojů, snadná montáž.",
    category: "party nábytek",
    featured: false,
    img: require("../assets/bbs/products/skladaci-bar.jpg"),
  },
  {
    id: "sklenice-na-vino",
    name: "Sklenice na víno (6 ks)",
    price: "48",
    weekendPrice: "60",
    bail: "200",
    context: "Sklenice na víno, objem 0,2 dcl.",
    category: "ostatní",
    featured: false,
    img: require("../assets/bbs/products/sklenice-na-vino.jpg"),
  },
  {
    id: "stojan-na-odpadky",
    name: "Stojan na odpadky",
    price: "50",
    weekendPrice: "60",
    bail: "200",
    context: "Praktický stojan na odpadky na pytle o objemu 120 l.",
    category: "party vybavení",
    featured: false,
    img: require("../assets/bbs/products/stojan-na-odpadky.jpg"),
  },
  {
    id: "svatebni-balicek-premium",
    name: "Svatební balíček premium",
    price: "14000",
    weekendPrice: "14000",
    bail: "15000",
    context: "Svatební balíček Premium obsahuje: party stan 6 x 12 m, 8 pivních setů se strečovým bílým potahem, 4 bistro stolky s bílým potahem, nůžkový bílý altán na obřad, stůl na obřad s bílým ubrusem, 1 nůžkový stan 3 x 6 m na raut, 3 pivní sety, 3 halogeny na osvětlení stanu, montáž a demontáž zdarma.",
    category: "party stany",
    featured: true,
    img: require("../assets/bbs/products/svatebni-balicek-premium.jpg"),
  },
  {
    id: "svatebni-balicek-standard",
    name: "Svatební balíček standard",
    price: "10000",
    weekendPrice: "10000",
    bail: "10000",
    context: "Svatební balíček Standard obsahuje: party stan 6 x 12 m, 8 pivních setů, 8 bílých jednorázových ubrusů, 2 bistro stolky se svatebním potahem, 2 halogeny na osvětlení stanu, montáž a demontáž.",
    category: "party stany",
    featured: true,
    img: require("../assets/bbs/products/svatebni-balicek-standard.jpg"),
  },
  {
    id: "svetelny-retez-1x5m",
    name: "Světelný řetěz 1x5 m",
    price: "180",
    weekendPrice: "250",
    bail: "500",
    context: "Světelný řetěz lze napojit do 15 m",
    category: "party vybavení",
    featured: false,
    img: require("../assets/bbs/products/svetelny-retez-1x5m.jpg"),
  },
  {
    id: "talir-melky-praha",
    name: "Talíř mělký Praha",
    price: "9",
    weekendPrice: "10",
    bail: "50",
    context: "Mělký talíř v průměru 22cm",
    category: "cateringové vybavení",
    featured: false,
    img: require("../assets/bbs/products/talir-melky-praha.jpg"),
  },
  {
    id: "vodni-lazen",
    name: "Vodní lázeň",
    price: "250",
    weekendPrice: "350",
    bail: "2000",
    context: "Vodní lázeň, vhodná k ohřevu hotových jídel, snadná obsluha, 3 nerezové gastro nádoby, termostat.",
    category: "cateringové vybavení",
    featured: false,
    img: require("../assets/bbs/products/vodni-lazen.jpg"),
  },
  {
    id: "vycepni-zarizeni",
    name: "Výčepní zařízení",
    price: "1000",
    weekendPrice: "1000",
    bail: "5000",
    context: "2 kohoutové suché profesionální chlazení. Výkon 115l / 1h",
    category: "cateringové vybavení",
    featured: false,
    img: require("../assets/bbs/products/vycepni-zarizeni.jpg"),
  },
];

export default products;
